import { Button, Notification, TextInput } from "@osttra/ds-react";
import React from "react";
import { AUTHORISED_USERS_NOTICE, PRIVACY_NOTICE } from "../../constants/Constants";
import { useOtpLogin } from "../../hooks/useOtpLogin";
import OsttraBlack from "../../images/OsttraBlack.svg";
import OsttraBg from "../../images/osttra-bg.png";
import "./OtpLogin.scss";

const OtpLogin = () => {
  const {
    otp,
    timer,
    canResend,
    error,
    isLoading,
    isResending,
    inputRefs,
    isLockedOut,
    handleChange,
    handleKeyDown,
    handlePaste,
    handleContinue,
    handleResend,
    handleCancel,
    canContinue,
  } = useOtpLogin();

  return (
    <div className="login-osttra-wrapper">
      <img src={OsttraBg} alt="osttra-background" className="osttra-background" />
      <main>
        <div className="otp-form-content">
          <img src={OsttraBlack} alt="osttra" className="brand-header-logo" />

          <form className="form-login-block otp-block" onSubmit={(e) => e.preventDefault()}>
            <h2>Login</h2>
            <p className="otp-instruction">Enter the 6-digit security code sent to your email.</p>
            <div className="t-flex t-items-center t-mb-24 t-gap-12">
              <div className="otp-inputs-container">
                {otp.map((digit, index) => (
                  <div key={index} className="otp-input-wrapper">
                    <TextInput
                      ref={(el: HTMLInputElement | null) => (inputRefs.current[index] = el)}
                      value={digit}
                      placeholder={digit ? "" : "-"}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(index, e.target.value)}
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => handleKeyDown(index, e)}
                      onPaste={handlePaste}
                      maxLength={1}
                      autoComplete="one-time-code"
                      aria-label={`Digit ${index + 1}`}
                      data-otp-input="true"
                      disabled={isLockedOut}
                    />
                  </div>
                ))}
              </div>
              <Button
                className={`resend-button ${canResend ? "t-primary" : ""}`}
                variant="ghost"
                onClick={handleResend}
                disabled={!canResend || isResending || isLockedOut}
                icon={"clock"}
              >
                {canResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
              </Button>
            </div>

            <div className="otp-actions">
              <Button type="primary" onClick={handleContinue} disabled={!canContinue} loading={isLoading}>
                Continue
              </Button>
              <Button onClick={handleCancel}>Go Back</Button>
            </div>

            {error && (
              <Notification isVisible subtle type="error">
                {error}
              </Notification>
            )}
          </form>

          <div className="otp-legal-notice">
            <p>{AUTHORISED_USERS_NOTICE}</p>
            <p>{PRIVACY_NOTICE}</p>
          </div>

          <footer className="otp-page-footer">
            <span className="footer-brand">
              <img src={OsttraBlack} alt="osttra" />
            </span>
            <span className="footer-tagline">
              THE GLOBAL <strong>POSTTRADE</strong> NETWORK
            </span>
          </footer>
        </div>
      </main>
    </div>
  );
};

export default OtpLogin;
